import { useCallback, useEffect, useState } from "react";
import {
  isOnline as readIsOnline,
  onApiReachabilityChange,
} from "src/utils/isOnline";

/**
 * Custom hook to determine API reachability for the desktop and web app.
 *
 * @returns A boolean indicating whether the API is currently reachable.
 */
export const useIsOnline = () => {
  const [isOnline, setIsOnline] = useState(readIsOnline);

  const syncOnlineState = useCallback(() => {
    setIsOnline(readIsOnline());
  }, []);

  useEffect(() => {
    if (!window.api?.onApiReachabilityChange) {
      return;
    }

    const unsubscribe = onApiReachabilityChange(syncOnlineState);
    syncOnlineState();

    return unsubscribe;
  }, [syncOnlineState]);

  return isOnline;
};
